import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {  NAV_DROPDOWN_DIRECTIVES } from './nav-dropdown.directive';

@NgModule({
  declarations: [
    NAV_DROPDOWN_DIRECTIVES
  ],
  imports: [
    BrowserModule
  ],
  exports: [
    NAV_DROPDOWN_DIRECTIVES
  ]
})
export class NavDropdownDirectiveModule {

}




// WEBPACK FOOTER //
// ./src/app/shared/directives/nav-dropdown/nav-dropdown.module.ts